import { render, staticRenderFns } from "./WindowImpacts.vue?vue&type=template&id=b1843ffa&scoped=true"
import script from "./WindowImpacts.vue?vue&type=script&lang=ts"
export * from "./WindowImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1843ffa",
  null
  
)

export default component.exports